<div class="flex-fill d-flex flex-column">
  <div class="m-1 grid-fill">
    <dx-data-grid #dataGrid [dataSource]="quotes" keyExpr="id" [columnAutoWidth]="false" (onRowDblClick)="rowDoubleClick($event)" (onExporting)="onExporting($event)">
      <dxi-column dataField="quoteNumber" caption="Quote #" width="80"></dxi-column>
      <dxi-column dataField="customer.companyName" caption="Customer" width="200"></dxi-column>
      <dxi-column dataField="projectName" width="200"></dxi-column>
      <dxi-column dataField="projectLocation" width="200"></dxi-column>
      <dxi-column dataField="shipTo" width="200"></dxi-column>
      <dxi-column dataField="quoteDate" caption="Date" width="100"></dxi-column>
      <dxi-column dataField="statusName" caption="Status" width="100"></dxi-column>
      <dxi-column dataField="total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
      <dxi-column width="100"></dxi-column>

      <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="quote-overview-grid"></dxo-state-storing>
      <dxo-selection [mode]="'multiple'"></dxo-selection>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <button class="btn btn-sm btn-success" (click)="open()">New</button>
        <button
          class="btn btn-sm btn-primary ms-2"
          (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          >
          Open
        </button>
        <button
          class="btn btn-sm btn-danger ms-4"
          (click)="delete(dataGrid.instance.getSelectedRowsData())"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          >
          Delete
        </button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (quotes) {
          <span class="me-3">
            <strong>
              {{ dataGrid.instance.totalCount() + " items" }}
              {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
            </strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
